<template>
  <DialogTemplate>
    <div class="f-center f-column px-2">
      <div class="ob_title">
        {{ $t('tour.title') }}
      </div>

      <div class="grpc_grid">
        <div
          v-for="option in options"
          :key="option.pathName"
          v-ripple
          class="grpc_btn anim-fade-in_slow"
          :data-tst="`path_${option.pathName}`"
          :class="{ grpc_btn_open: mobile }"
          @click="startTour(option.pathName)"
        >
          <div class="d-flex">
            <div class="grpc_icon mr-4">
              <v-icon :size="mobile ? 'large' : 'x-large'">
                {{ option.icon }}
              </v-icon>
            </div>
            <div
              v-show="!mobile"
              class="ml-auto grpc_icon grpc_icon_hidden"
            >
              <v-btn icon>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="f-column grpc_title-box">
            <div class="grpc_title">
              {{ option.text }}
            </div>
            <div
              v-show="!mobile"
              class="grpc_subtitle"
            >
              {{ option.sub }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        data-tst="btn_apply_filter"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyFilterHelpDialog',
  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    async startTour(name) {
      if (this.$route.name !== name) {
        await this.$router.push({ name }).catch(() => {})
      }
      this.close()
      setTimeout(() => {
        this.$store.dispatch('globals_action', 'show_tour')
      }, 300)
    },
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    options() {
      return [
        {
          icon: 'mdi-school',
          sub: this.$t('onboarding.sub_solution', {
            num: `${(10000000).toLocaleString(this.$i18n.locale)}+`,
          }),
          text: this.$t('onboarding.browse'),
          pathName: 'StudySolutions',
        },
        {
          icon: 'mdi-google-controller',
          sub: this.$t('onboarding.sub_practice'),
          text: this.$t('onboarding.practice'),
          pathName: 'PracticeTrainer',
        },
        // {
        //   icon: 'mdi-table-edit',
        //   sub: this.$t('links.practice_range_builder_sub'),
        //   text: this.$t('links.practice_range_builder'),
        //   pathName: 'PracticeRangeBuilder',
        // },
        // {
        //   icon: 'mdi-chart-box-outline',
        //   sub: this.$t('onboarding.sub_reports'),
        //   text: this.$t('onboarding.reports'),
        //   pathName: 'StudyReports',
        // },
      ]
    },
    mobile() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 1023
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  color: var(--clr-black-3);
  fill: currentColor;
  svg {
    width: 7rem;
  }
}
.ob {
  &_title {
    font-size: 2rem;
    padding: 0.5rem 1rem;
    text-align: center;
    font-weight: 500;
  }
}
.grpc {
  &_grid {
    display: grid;
    grid-gap: 12px;
    // min-width: 32rem;
    width: 100%;
    margin: 2rem auto;
  }
  &_btn {
    position: relative;
    border-radius: 8px;
    border: solid 1px var(--clr-black-3);
    transition: 0.2s;
    cursor: pointer;
    // padding: 2rem;
    padding: 2rem 2rem 7rem 2rem;
    &:hover {
      background: var(--clr-black-3);
      border: solid 1px var(--clr-black-3);
      .grpc_icon_hidden {
        opacity: 1;
      }
    }
    .grpc_icon {
      i {
        color: var(--clr-primary);
      }
    }
    .grpc_subtitle {
      height: 4rem;
    }
    .grpc_title-box {
      bottom: 0rem;
    }
    &_open {
      padding: 1rem !important;
      display: flex;
      align-items: center;
      .grpc_icon {
        i {
          color: var(--clr-primary) !important;
        }
      }
      .grpc_title-box {
        position: relative !important;
        // left: 6rem;
        bottom: unset !important;
      }
    }
    .grpc_icon_hidden {
      opacity: 0;
      transition: 0.3s;
    }
  }
  .grpc_icon_hidden {
    opacity: 0;
    transition: 0.3s;
  }
  &_title-box {
    transition: 0.2s;
    bottom: 2rem;
    position: absolute;
  }
  &_title {
    font-size: 1.5rem;
    font-weight: 500;
    text-align: left;
  }
  &_subtitle {
    transition: 0.2s;
    font-size: 1rem;
    height: 0px;
    overflow: hidden;
  }
}
</style>
